import React, { Component } from 'react';
import { FaExclamationCircle as Warning, FaCheckCircle as Ok, FaTimesCircle as Error } from 'react-icons/fa';
import Loader from 'react-loader-advanced';
import JSONTree from 'react-json-tree';


import './index.css'
import HttpClient from "../../../libs/http";
const http = new HttpClient()
const qs = require('query-string')
const query = qs.parse(window.location.search)
const environment = query.environment || query.env || 'stable'
const theme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#0a0c1c',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633'
}; // for json tree visualizing
export default class ResultDetail extends Component {
  constructor(props) {
    super(props)
    this.worker = null
    this.state = {
      result: { date: new Date(), html: null },
      last_updated: new Date().toString("HH:mm:ss"),
      loaded: false
    }
  }
  componentWillMount() {
    this.getData()
  }
  getData = async () => {
    try {
      let result = await http.GET(`/api/pvt/healthcheck/results/${query.id}?repository=${environment}&month=${query.month}`)
      let new_state = this.state
      result.date = new Date(result.date)
      new_state.result = result
      new_state.last_updated = new Date().toString("HH:mm:ss")
      new_state.loaded = true
      this.setState(new_state)
    }
    catch (err) {
      console.log(err)
    }
  }

  getStatusIcon = (status) => {
    let size = 20;
    switch (status) {
      case 'error':
        return <Error className="red bg-white br4 mb2" size={size} />;
      case 'warning':
        return <Warning className="gold bg-white br4 mb2" size={size} />;
      default:
        return <Ok className="green bg-white br4 mb2" size={size} />;
    }
  }

  testJSON = (str) => {
    try {
      JSON.parse(str)
    } catch (e) {
      console.debug('not a valid json, rendering as html')
      return false
    }
    return true
  }

  render() {
    return (

      <Loader show={!this.state.loaded} message={'Loading...'} backgroundStyle={{ backgroundColor: 'black' }}>
        <div className="ph2 white">
          <div className="pa0 mt4-l flex-l flex-column-l">
            <h3 className="mv0 f2 fw1 tc pv4">{this.state.result.module} - {this.state.result.date.toString("dd/MM/yyyy HH:mm:ss")}</h3>
            <span className="items-center tc f3">{this.getStatusIcon(this.state.result.status)} {this.state.result.title}</span>
            <span className="items-center tc f4">Elapsed {this.state.result.eTime}</span>
            {
              this.state.result.image
                ? <div className="tc image">
                  <h3 className="mv0 f2 fw1 tc pv4">Image</h3>
                  <img className="db tc image center" src={this.state.result.image} />
                </div>
                : ""
            }
            <h3 className="mv0 f2 fw1 tc pv4">Evidence</h3>
            {
              this.state.result.html
                ? this.testJSON(this.state.result.html)
                  ? <div className="mh5">
                    <JSONTree
                      data={JSON.parse(this.state.result.html)}
                      theme={{ extend: theme }}
                      invertTheme={false}
                      shouldExpandNode={() => true}
                      hideRoot={true} />
                  </div>
                  : <div dangerouslySetInnerHTML={{ __html: this.state.result.html }} />
                : <div className="tc">No evidence found</div>
            }
          </div>
        </div>
      </Loader>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Healthcheck/ResultDetail/index.js